import React, { useContext, type JSX } from 'react';

import RutinUrvalListQuery from '../SavedUrval/Queries/RutinUrvalListQuery/RutinUrvalListQuery';
import NodeUrvalQuery from '../SavedUrval/Queries/NodeUrvalQuery/NodeUrvalQuery';
import {
  IUIUrval,
  RutinUrvalType,
  NodeUrvalType,
} from '../../../../Types/UrvalTypes';
import { ApolloError } from '@apollo/client';
import { ActiveRoutineContext } from '../../../../Features/Routing/ActiveRoutine/ActiveRoutineContext';
import { getInitialUrval } from './Utils/DefaultUrvalUtils';

interface IChildrenProps {
  loading: boolean;
  error?: ApolloError | Error;
  pickedSavedUrval?: NodeUrvalType;
}

interface IProps {
  urval: IUIUrval | null;
  collectionName: string;
  groupID?: string;
  codeSystemID?: string;
  usageCode?: string;
  children: (result: IChildrenProps) => JSX.Element;
  kodplanUrval: boolean;
  rutinID?: number;
}

/** Component that renders the Urval component and if the urval prop is undefined, a default or favorite urval will be loaded */
const DefaultUrval: React.FunctionComponent<IProps> = props => {
  const activeRoutineContext = useContext(ActiveRoutineContext);

  return (
    <RutinUrvalListQuery
      collectionName={props.collectionName}
      groupID={props.groupID}
      codeSystemID={props.codeSystemID}
      usageCode={props.usageCode}
      kodplanUrval={props.kodplanUrval}
      routineID={props.rutinID}
    >
      {({ loading: listLoading, error: listError, rutinUrvalList }) => {
        let urval: IUIUrval | null = props.urval;
        let pickedSavedUrvalLight: RutinUrvalType | undefined;

        // Om urval är null eller undefined, ta favorit- eller rutinstandard-urval, annars kolla om urval är ett sparat urval
        if (urval == null) {
          pickedSavedUrvalLight = getInitialUrval(
            rutinUrvalList || [],
            activeRoutineContext?.initialUrvalId
          );
        } else {
          const { savedUrvalProps } = urval;
          if (savedUrvalProps != null) {
            pickedSavedUrvalLight = (rutinUrvalList || []).find(
              rutinUrval => savedUrvalProps.id === rutinUrval.id
            );
          }
        }

        return (
          <NodeUrvalQuery
            id={
              pickedSavedUrvalLight != null
                ? pickedSavedUrvalLight.id
                : undefined
            }
            useCache
          >
            {({ loading, error, urval: pickedSavedUrval }) => {
              return props.children({
                loading: loading || listLoading,
                error: error != null ? error : listError,
                pickedSavedUrval,
              });
            }}
          </NodeUrvalQuery>
        );
      }}
    </RutinUrvalListQuery>
  );
};

export default DefaultUrval;
